import { useState } from "react";
import { marketplaceService } from "@/services/marketplace/MarketplaceService";
import { useOrganizationContext } from "@/contexts/OrganizationContext";
import { toast } from "react-toastify";

// Definição dos planos do CRM
export const crmPlans = [
  {
    title: "Plano Padrão - 50 mensagens",
    amount: import.meta.env.VITE_ENV === "production" ? 50.0 : 1.0,
    description: "Pacote com 50 mensagens para relacionamento com o paciente",
    productReference: "crm50",
  },
  {
    title: "Plano Premium - 100 mensagens",
    amount: import.meta.env.VITE_ENV === "production" ? 100.0 : 1.0,
    description: "Pacote com 100 mensagens para relacionamento com o paciente",
    productReference: "crm100",
  },
] as const;

export type CRMPlan = (typeof crmPlans)[number];

interface UseCRMPaymentOptions {
  onSuccess?: () => void;
}

export function useCRMPayment(options?: UseCRMPaymentOptions) {
  const [paymentLink, setPaymentLink] = useState<string | null>(null);
  const { organizationId: rawOrganizationId } = useOrganizationContext();

  // Em telas `src-next` (fora do Provider) precisamos tentar ler o org real do
  // localStorage antes do fallback temporário.
  const organizationIdFromStorage =
    localStorage.getItem("organizationId") || undefined;

  const fallbackOrganizationId = "05490544000100";
  const organizationId =
    rawOrganizationId &&
    rawOrganizationId.trim() &&
    rawOrganizationId !== fallbackOrganizationId
      ? rawOrganizationId
      : organizationIdFromStorage || fallbackOrganizationId;

  const [isGeneratingPaymentLink, setIsGeneratingPaymentLink] = useState(
    false,
  );

  const handleActivateCRMPlan = async (plan: CRMPlan) => {
    try {
      setIsGeneratingPaymentLink(true);
      console.debug("[useCRMPayment] generating paymentLink", {
        productReference: plan.productReference,
        organizationId,
        amount: plan.amount,
      });
      const link = await marketplaceService.getProductPaymentLink({
        productReference: plan.productReference,
        organizationId,
        amount: plan.amount,
        description: plan.description,
      });
      setPaymentLink(link);
      console.log("Link de pagamento gerado:", link);
    } catch (error) {
      console.error("Erro ao gerar link de pagamento:", error);
      toast.error(
        "Erro ao gerar link de pagamento. Por favor, tente novamente."
      );
    } finally {
      setIsGeneratingPaymentLink(false);
    }
  };

  const resetPaymentLink = () => {
    setPaymentLink(null);
    options?.onSuccess?.();
  };

  return {
    paymentLink,
    setPaymentLink,
    handleActivateCRMPlan,
    resetPaymentLink,
    crmPlans,
    isGeneratingPaymentLink,
  };
}
